"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoinListType = void 0;
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var KeyboardArrowLeft_1 = __importDefault(require("@mui/icons-material/KeyboardArrowLeft"));
var KeyboardArrowRight_1 = __importDefault(require("@mui/icons-material/KeyboardArrowRight"));
var KeyboardDoubleArrowLeft_1 = __importDefault(require("@mui/icons-material/KeyboardDoubleArrowLeft"));
var KeyboardDoubleArrowRight_1 = __importDefault(require("@mui/icons-material/KeyboardDoubleArrowRight"));
var commonTypes_1 = require("../../shared/types/commonTypes");
var react_i18next_1 = require("react-i18next");
var SearchComponent_1 = __importDefault(require("../../shared/components/CrudeComponents/SearchComponent"));
var FilterComponent_1 = __importDefault(require("../../shared/components/CrudeComponents/FilterComponent"));
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../store/crude/crude.selector");
var configurationTypes_1 = require("../../shared/types/configurationTypes");
var IconComponent_1 = __importDefault(require("../../shared/components/FormComponents/IconComponent"));
var getFetchHeaders_1 = __importDefault(require("../../shared/util/getFetchHeaders"));
var translateMessage_1 = __importDefault(require("../../shared/util/translateMessage"));
var messageTypes_1 = require("../../shared/types/messageTypes");
var deleteEntityData_1 = __importDefault(require("../../fetch/deleteEntityData"));
var crudeActions = __importStar(require("../../store/crude/crude.actions"));
var createEntityData_1 = __importDefault(require("../../fetch/createEntityData"));
var DataEditView_1 = __importDefault(require("../DataEditView/DataEditView"));
var CrudeDialogComponent_1 = __importDefault(require("../../shared/components/CrudeComponents/CrudeDialogComponent"));
var crude_actions_1 = require("../../store/crude/crude.actions");
var styles_1 = require("@mui/styles");
var JoinEntityElement_1 = __importDefault(require("./JoinEntityElement"));
var TooltipComponent_1 = __importDefault(require("../../shared/components/MessageComponents/TooltipComponent"));
var LabelWithTooltipComponent_1 = __importDefault(require("../../shared/components/MessageComponents/LabelWithTooltipComponent"));
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var DeleteForever_1 = __importDefault(require("@mui/icons-material/DeleteForever"));
var Backspace_1 = __importDefault(require("@mui/icons-material/Backspace"));
var Clear_1 = __importDefault(require("@mui/icons-material/Clear"));
var HighlightOff_1 = __importDefault(require("@mui/icons-material/HighlightOff"));
var getListLabelTemplateContent_1 = __importDefault(require("../../shared/util/getListLabelTemplateContent"));
var dompurify_1 = __importDefault(require("dompurify"));
var crudeHooks_1 = require("../../crudeHooks");
var JoinListType;
(function (JoinListType) {
    JoinListType["entityList"] = "entityList";
    JoinListType["joinList"] = "joinList";
})(JoinListType = exports.JoinListType || (exports.JoinListType = {}));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    paper: {
        border: "2px solid " + theme.palette.grey.A200,
        boxShadow: 'none !important',
    },
}); });
var JoinEntity = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var t = react_i18next_1.useTranslation().t;
    var dispatch = react_redux_1.useDispatch();
    var classes = useStyles();
    var theme = material_1.useTheme();
    var context = react_1.useContext(crudeHooks_1.CrudeContext);
    var crudeHookProps = context.crudeHookProps;
    var TranslationComponent = crudeHookProps && crudeHookProps.translationComponent;
    var temporaryJoinData = react_redux_1.useSelector(crude_selector_1.getTemporaryJoinData);
    var _l = react_1.default.useState(props.entity), entity = _l[0], setEntity = _l[1];
    var _m = react_1.default.useState(props.joinEntity), joinEntity = _m[0], setJoinEntity = _m[1];
    react_1.useEffect(function () {
        setEntity(props.entity);
        setJoinEntity(props.joinEntity);
    }, [props.entity, props.joinEntity]);
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var storedTableFilterSettings = react_redux_1.useSelector(crude_selector_1.getTableFilterSettings);
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var mainEntity = react_redux_1.useSelector(crude_selector_1.getActiveEntity);
    var crudeLicense = react_redux_1.useSelector(crude_selector_1.getCrudeLicense);
    var extendedTableLicense = crudeLicense.extendedTable.available;
    var maxThumbnails = extendedTableLicense ? appLayout.maxThumbnails : undefined;
    var joinEntityLayout = props.layout ? props.layout : configurationTypes_1.JoinEntityLayout.joinEntity;
    var joinEntitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === joinEntity; });
    var joinEntityDescription = ((_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[joinEntity]) === null || _b === void 0 ? void 0 : _b.description) || ((_d = (_c = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _c === void 0 ? void 0 : _c.entity[joinEntity]) === null || _d === void 0 ? void 0 : _d.title) || joinEntity;
    var entityDescription = ((_f = (_e = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _e === void 0 ? void 0 : _e.entity[entity]) === null || _f === void 0 ? void 0 : _f.title) || joinEntity;
    var fetchHeaders = crudeConfig.api.headers ? getFetchHeaders_1.default(crudeConfig.api.headers) : {};
    var getFilteredEntityData = function (data) {
        var filteredEntityData = data.data;
        // Suche
        if (storedTableFilterSettings[entity][props.treeViewLevel].search !== '') {
            filteredEntityData = [];
            var regExp_1 = new RegExp((storedTableFilterSettings[entity][props.treeViewLevel].search || '')
                .replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i');
            data.data.map(function (element) {
                // previewString druchsuchen
                var idColumn = joinEntitySchema && joinEntitySchema.idColumn;
                var id = idColumn && element[idColumn];
                var preview = id && data.entityReferencePreviews[entity][id];
                if (preview && preview.match(regExp_1)) {
                    filteredEntityData.push(element);
                }
            });
        }
        var tempData = filteredEntityData;
        // Filter
        if (Object.keys(storedTableFilterSettings[entity][props.treeViewLevel].filter).length > 0) {
            filteredEntityData = [];
            tempData.map(function (element) {
                var useElement = true;
                Object.keys(storedTableFilterSettings[entity][props.treeViewLevel].filter).map(function (filter) {
                    if (element[filter.replace('value_', '')] !== storedTableFilterSettings[entity][props.treeViewLevel].filter[filter]) {
                        useElement = false;
                    }
                });
                if (useElement) {
                    filteredEntityData.push(element);
                }
            });
        }
        return filteredEntityData;
    };
    var setTemporaryData = function (tempJoinEntityData) {
        var _a;
        // hier werden die Daten temporär gesetzt, damit die Anzeige im FE das Anlegen und Löschen der JoinEntites simulieren kann
        var newEntityData = __spreadArrays(entityData.data);
        var newJoinData = [];
        var joinColumns = joinEntitySchema && joinEntitySchema.columns;
        tempJoinEntityData.data.map(function (join) {
            var chosenElement = false;
            joinColumns && joinColumns.forEach(function (column) {
                var _a;
                if ((joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && ((_a = temporaryJoinData[joinEntity]) === null || _a === void 0 ? void 0 : _a.find(function (temp) { return temp.data[column.name] === join[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn]; }))) {
                    chosenElement = true;
                }
            });
            if (chosenElement) {
                if (!newEntityData.find(function (elem) { return JSON.stringify(elem) === JSON.stringify(join); })) {
                    newEntityData.push(join);
                }
            }
            else {
                if (!newJoinData.find(function (elem) { return JSON.stringify(elem) === JSON.stringify(join); })) {
                    newJoinData.push(join);
                }
            }
        });
        newEntityData.map(function (rejoin) {
            var chosenElement = false;
            joinColumns && joinColumns.forEach(function (column) {
                var _a;
                if ((joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && ((_a = temporaryJoinData[joinEntity]) === null || _a === void 0 ? void 0 : _a.find(function (temp) { return temp.data[column.name] === rejoin[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn]; }))) {
                    chosenElement = true;
                }
            });
            if (!chosenElement) {
                // prüfen, ob noch in EntityListe und ggf. entfernen
                joinColumns && joinColumns.forEach(function (column) {
                    if (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) {
                        var id = newEntityData.findIndex(function (elem) {
                            return elem[column.name] === rejoin[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
                        });
                        if (id >= 0) {
                            newEntityData.splice(id, 1);
                        }
                    }
                });
            }
        });
        var newReferences = entityData.entityReferencePreviews[entity]
            ? Object.assign(entityData.entityReferencePreviews[entity], tempJoinEntityData.entityReferencePreviews[entity])
            : tempJoinEntityData.entityReferencePreviews[entity];
        setEntityData(__assign(__assign({}, entityData), { data: newEntityData, entityReferencePreviews: (_a = {}, _a[entity] = newReferences, _a) }));
        setJoinEntityData(__assign(__assign({}, tempJoinEntityData), { data: newJoinData, totalPages: tempJoinEntityData.totalPages, totalElements: tempJoinEntityData.totalElements }));
    };
    var initialData = function (data) {
        var preparedData;
        if (data && data.data) {
            preparedData = data;
        }
        else {
            preparedData = {
                data: [],
                instancePermissions: {},
                entityReferencePreviews: {},
                thumbnailData: {},
                hasChildren: {},
                joinContext: {},
                totalPages: 0,
                totalElements: 0,
            };
        }
        preparedData.data.map(function (element) {
            element.selected = false;
            return element;
        });
        return preparedData;
    };
    var _o = react_1.default.useState(initialData(props.entityData)), entityData = _o[0], setEntityData = _o[1];
    var _p = react_1.default.useState(initialData(props.joinEntityData)), joinEntityData = _p[0], setJoinEntityData = _p[1];
    var _q = react_1.default.useState(), singleEntity = _q[0], setSingleEntity = _q[1];
    react_1.useEffect(function () {
        setEntityData(props.entityData);
        setJoinEntityData(props.joinEntityData);
        props.mainEntityId === 'new' && setTemporaryData(props.joinEntityData);
    }, [props.entityData, props.joinEntityData]);
    react_1.useEffect(function () {
        props.mainEntityId === 'new' && setEntityData({
            data: [],
            instancePermissions: {},
            entityReferencePreviews: {},
            thumbnailData: {},
            hasChildren: {},
            joinContext: {},
            totalPages: 0,
            totalElements: 0,
        });
    }, [props.joinEntity]);
    var getInitialFilterSettings = function () {
        var rowsPerPageOptions = (appLayout === null || appLayout === void 0 ? void 0 : appLayout.rowsPerPageOptions) || [10, 25, 50, 100];
        return __assign(__assign({}, storedTableFilterSettings[entity][props.treeViewLevel]), { page: 0, search: '', pageSize: rowsPerPageOptions[0], filter: {} });
    };
    var _r = react_1.useState(getInitialFilterSettings()), entityFilterSettings = _r[0], setEntityFilterSettings = _r[1];
    var _s = react_1.default.useState(getInitialFilterSettings()), joinFilterSettings = _s[0], setJoinFilterSettings = _s[1];
    var _t = react_1.useState(), fetchResponse = _t[0], setFetchResponse = _t[1];
    react_1.useEffect(function () {
        var rowsPerPageOptions = (appLayout === null || appLayout === void 0 ? void 0 : appLayout.rowsPerPageOptions) || [10, 25, 50, 100];
        setEntityFilterSettings(__assign(__assign({}, entityFilterSettings), { page: 0, pageSize: rowsPerPageOptions[0] }));
        setJoinFilterSettings(__assign(__assign({}, joinFilterSettings), { page: 0, pageSize: rowsPerPageOptions[0] }));
    }, [entity]);
    react_1.useEffect(function () {
        props.changeEntityFilterSettings && props.changeEntityFilterSettings(entityFilterSettings);
    }, [entityFilterSettings]);
    react_1.useEffect(function () {
        props.changeJoinFilterSettings && props.changeJoinFilterSettings(joinFilterSettings);
    }, [joinFilterSettings]);
    react_1.useEffect(function () {
        if (fetchResponse) {
            props.reloadJoinEntityData && props.reloadJoinEntityData();
            if (crudeLabels && fetchResponse.message) {
                var text = translateMessage_1.default(fetchResponse.message, crudeLabels, props.entity);
                var message = {
                    eventType: fetchResponse.eventType,
                    severity: fetchResponse.status && fetchResponse.status < 400 ? messageTypes_1.Severity.success : messageTypes_1.Severity.error,
                    message: text,
                };
                fetchResponse && dispatch(crudeActions.addMessage(message));
            }
        }
    }, [fetchResponse]);
    react_1.useEffect(function () {
        setTemporaryData(joinEntityData);
    }, [temporaryJoinData[joinEntity]]);
    var handleSwitchLeft = function (all) {
        var joinColumns = joinEntitySchema && joinEntitySchema.columns;
        var tempArray = temporaryJoinData[joinEntity] ? __spreadArrays(temporaryJoinData[joinEntity]) : [];
        joinEntityData.data.forEach(function (createElement) {
            // createdElement ist das gewählte Element für den ein join zu der entity erstellt werden soll
            if (createElement.selected || all) {
                var newJoin_1 = {};
                var selectedJoinEntity = crudeSchema && crudeSchema.find(function (elem) { return elem.name === joinEntity; });
                var urlEntity_1 = selectedJoinEntity && selectedJoinEntity.outgoingReferences.find(function (elem) { return (elem.targetEntity === mainEntity && elem.sourceColumn === props.embeddingEntityFilter.key); });
                var tabEntity_1 = selectedJoinEntity && selectedJoinEntity.outgoingReferences.find(function (elem) { return elem.targetEntity === entity && elem !== urlEntity_1; });
                joinColumns && joinColumns.forEach(function (column) {
                    if (tabEntity_1 && column.name === tabEntity_1.sourceColumn) {
                        newJoin_1[column.name] = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && createElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
                    }
                    if (urlEntity_1 && column.name === urlEntity_1.sourceColumn) {
                        newJoin_1[column.name] = props.mainEntityId;
                    }
                });
                if (props.mainEntityId !== 'new') {
                    createEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, joinEntity, newJoin_1, fetchHeaders, setFetchResponse);
                }
                else {
                    tempArray.push({ entity: joinEntity, data: newJoin_1 });
                }
            }
        });
        // speichern der tempJoins an der Stelle JoinEntity, falls mehrere an einem neuen Element sind
        var newTempJoinData = __assign({}, temporaryJoinData);
        newTempJoinData[joinEntity] = tempArray;
        props.mainEntityId === 'new' && dispatch(crudeActions.setTemporaryJoinData(newTempJoinData));
    };
    var handleSwitchRight = function (all) {
        var joinColumns = joinEntitySchema && joinEntitySchema.columns;
        var tempArray = temporaryJoinData[joinEntity] ? __spreadArrays(temporaryJoinData[joinEntity]) : [];
        var newArray = [];
        entityData.data.forEach(function (deleteElement) {
            if (deleteElement.selected || all) {
                if (props.mainEntityId !== 'new') {
                    var entityId = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && entityData.joinContext[deleteElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn]].id;
                    entityId && deleteEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, joinEntity, fetchHeaders, entityId, setFetchResponse);
                }
                else {
                    joinColumns && joinColumns.forEach(function (column) {
                        var changeElement = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && tempArray.find(function (elem) { return elem.data[column.name] === deleteElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn]; });
                        if (changeElement) {
                            var index_1 = tempArray.findIndex(function (object) { return object.data[column.name] === changeElement.data[column.name]; });
                            if (index_1 >= 0) {
                                tempArray.map(function (elem, id) {
                                    if (index_1 !== id) {
                                        newArray.push(elem);
                                    }
                                });
                            }
                        }
                    });
                }
            }
        });
        var newTempJoinData = __assign({}, temporaryJoinData);
        newTempJoinData[joinEntity] = newArray;
        props.mainEntityId === 'new' && dispatch(crudeActions.setTemporaryJoinData(newTempJoinData));
    };
    var handleChangeEntityPage = function (e, page) {
        var newSettings = __assign(__assign({}, entityFilterSettings), { page: page });
        setEntityFilterSettings(newSettings);
    };
    var handleChangeEntityPageSize = function (e) {
        var newSettings = __assign(__assign({}, entityFilterSettings), { pageSize: Number.isInteger(Number.parseFloat(e.target.value)) ? Number.parseInt(e.target.value) : entityFilterSettings.page, page: 0 });
        setEntityFilterSettings(newSettings);
    };
    var handleChangeJoinPage = function (e, page) {
        var newSettings = __assign(__assign({}, joinFilterSettings), { page: page });
        setJoinFilterSettings(newSettings);
    };
    var handleChangeJoinPageSize = function (e) {
        var newSettings = __assign(__assign({}, joinFilterSettings), { pageSize: Number.isInteger(Number.parseFloat(e.target.value)) ? Number.parseInt(e.target.value) : joinFilterSettings.page, page: 0 });
        setJoinFilterSettings(newSettings);
    };
    var disabledJoinColumns = [
        props.embeddingEntityFilter.key,
    ];
    ((_h = (_g = crudeSchema === null || crudeSchema === void 0 ? void 0 : crudeSchema.find(function (elem) { return elem.name === entity; })) === null || _g === void 0 ? void 0 : _g.incomingReferences.find(function (elem) { return elem.sourceEntity === joinEntity; })) === null || _h === void 0 ? void 0 : _h.sourceColumn) &&
        disabledJoinColumns.push((_k = (_j = crudeSchema === null || crudeSchema === void 0 ? void 0 : crudeSchema.find(function (elem) { return elem.name === entity; })) === null || _j === void 0 ? void 0 : _j.incomingReferences.find(function (elem) { return elem.sourceEntity === joinEntity; })) === null || _k === void 0 ? void 0 : _k.sourceColumn);
    var createAllowed = joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.entityPermissions.createAllowed;
    var deleteAllowed = joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.entityPermissions.deleteAllowedByDefault;
    var _u = react_1.useState(), showJoinEntityMultiSelectErrorMessage = _u[0], setShowJoinEntityMultiSelectErrorMessage = _u[1];
    var StyledPopper = function (props) {
        return (react_1.default.createElement(material_1.Popper, __assign({}, props, { disablePortal: false, style: {
                width: props.anchorEl.clientWidth,
                border: "2px solid " + theme.palette.primary.main,
                borderRadius: '4px',
                inset: '5px auto auto 0px !important',
                '& .MuiAutocomplete-option:hover': {
                    color: theme.palette.primary.main,
                },
                '& .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
                    backgroundColor: theme.palette.grey.A100,
                },
                '& .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"]': {
                    backgroundColor: 'transparent',
                },
            }, placement: 'bottom-end' })));
    };
    var getClearIcon = function () {
        var _a, _b, _c, _d, _e;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            ((_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.deleteIcon) === 'delete' &&
                react_1.default.createElement(Delete_1.default, null),
            ((_b = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _b === void 0 ? void 0 : _b.deleteIcon) === 'deleteForever' &&
                react_1.default.createElement(DeleteForever_1.default, null),
            ((_c = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _c === void 0 ? void 0 : _c.deleteIcon) === 'backspace' &&
                react_1.default.createElement(Backspace_1.default, null),
            ((_d = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _d === void 0 ? void 0 : _d.deleteIcon) === 'clear' &&
                react_1.default.createElement(Clear_1.default, null),
            ((_e = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _e === void 0 ? void 0 : _e.deleteIcon) === 'highlightOff' &&
                react_1.default.createElement(HighlightOff_1.default, null)));
    };
    var _v = react_1.useState(undefined), template = _v[0], setTemplate = _v[1];
    var _w = react_1.useState(false), onlyPositiveBooleans = _w[0], setOnlyPositiveBooleans = _w[1];
    react_1.useEffect(function () {
        // auslesen des Templates, falls vorhanden
        var templateObject = extendedTableLicense && appLayout.entityTemplates && appLayout.entityTemplates.find(function (entityTemplate) { return entityTemplate.name === props.joinEntity; });
        setTemplate(templateObject ? templateObject.template : undefined);
        setOnlyPositiveBooleans(templateObject && templateObject.onlyPositiveBooleans ? templateObject.onlyPositiveBooleans : false);
    }, [props.joinEntity]);
    var getTemplateLabel = function (element, elementId) {
        var templateLabel = template && crudeSchema && joinEntitySchema && getListLabelTemplateContent_1.default(template, crudeSchema, joinEntitySchema, element, entity, crudeConfig, onlyPositiveBooleans, crudeLabels, entityData.entityReferencePreviews, entityData.joinContext[elementId], entityData.thumbnailData[elementId], maxThumbnails);
        return templateLabel;
    };
    var getMultiSelectDropdownData = function () {
        var data = [];
        var newEntityPreviews = entityData.entityReferencePreviews;
        entityData.data.map(function (element) {
            var elementId = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && element[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
            var listLabel = elementId && newEntityPreviews && newEntityPreviews[entity] ? newEntityPreviews[entity] && newEntityPreviews[entity][elementId] : elementId;
            var templateLabel = elementId && getTemplateLabel(element, elementId);
            listLabel = templateLabel || listLabel;
            data.push({
                key: elementId,
                value: listLabel,
            });
        });
        var newJoinEntityPreviews = joinEntityData.entityReferencePreviews;
        joinEntityData.data.map(function (element) {
            var elementId = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && element[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
            var listLabel = elementId && newJoinEntityPreviews && newJoinEntityPreviews[entity] ? newJoinEntityPreviews[entity] && newJoinEntityPreviews[entity][elementId] : elementId;
            var templateLabel = elementId && getTemplateLabel(element, elementId);
            listLabel = templateLabel || listLabel;
            data.push({
                key: elementId,
                value: listLabel,
            });
        });
        return data;
    };
    var getMultiSelectValues = function () {
        var data = [];
        var newEntityPreviews = entityData.entityReferencePreviews;
        entityData.data.map(function (element, index) {
            var elementId = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && element[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
            var listLabel = elementId && newEntityPreviews && newEntityPreviews[entity] ? newEntityPreviews[entity] && newEntityPreviews[entity][elementId] : elementId;
            var templateLabel = elementId && getTemplateLabel(element, elementId);
            listLabel = templateLabel || listLabel;
            data.push({
                key: elementId,
                value: listLabel,
            });
        });
        return data;
    };
    var handleChangeMultiSelectDropdown = function (values) {
        var min = props.min;
        var max = props.max;
        if (((min && values.length >= min) || !min) && ((max && values.length <= max) || !max)) {
            setShowJoinEntityMultiSelectErrorMessage(undefined);
            var oldValues = getMultiSelectValues();
            // compare lists
            var element_1;
            if (oldValues.length > values.length) {
                oldValues.map(function (old) {
                    if (!values.find(function (elem) { return elem.key === old.key; })) {
                        element_1 = old; // > delete
                    }
                });
            }
            else {
                values.map(function (newValue) {
                    if (values.find(function (old) { return old.key === newValue.key; })) {
                        element_1 = newValue; // > create
                    }
                });
            }
            var handling = oldValues.length > values.length ? 'delete' : 'create';
            if (handling === 'create') {
                var joinColumns_1 = joinEntitySchema && joinEntitySchema.columns;
                var tempArray_1 = temporaryJoinData[joinEntity] ? __spreadArrays(temporaryJoinData[joinEntity]) : [];
                joinEntityData.data.forEach(function (createElement) {
                    var elementId = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && createElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
                    if (element_1 && elementId === (element_1 === null || element_1 === void 0 ? void 0 : element_1.key)) {
                        // createdElement ist das gewählte Element für den ein join zu der entity erstellt werden soll
                        var newJoin_2 = {};
                        var selectedJoinEntity = crudeSchema && crudeSchema.find(function (elem) { return elem.name === joinEntity; });
                        var urlEntity_2 = selectedJoinEntity && selectedJoinEntity.outgoingReferences.find(function (elem) { return (elem.targetEntity === mainEntity && elem.sourceColumn === props.embeddingEntityFilter.key); });
                        var tabEntity_2 = selectedJoinEntity && selectedJoinEntity.outgoingReferences.find(function (elem) { return elem.targetEntity === entity && elem !== urlEntity_2; });
                        joinColumns_1 && joinColumns_1.forEach(function (column) {
                            if (tabEntity_2 && column.name === tabEntity_2.sourceColumn) {
                                newJoin_2[column.name] = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && createElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
                            }
                            if (urlEntity_2 && column.name === urlEntity_2.sourceColumn) {
                                newJoin_2[column.name] = props.mainEntityId;
                            }
                        });
                        if (props.mainEntityId !== 'new') {
                            createEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, joinEntity, newJoin_2, fetchHeaders, setFetchResponse);
                        }
                        else {
                            tempArray_1.push({ entity: joinEntity, data: newJoin_2 });
                        }
                    }
                });
                // speichern der tempJoins an der Stelle JoinEntity, falls mehrere an einem neuen Element sind
                var newTempJoinData = __assign({}, temporaryJoinData);
                newTempJoinData[joinEntity] = tempArray_1;
                props.mainEntityId === 'new' && dispatch(crudeActions.setTemporaryJoinData(newTempJoinData));
            }
            else {
                var joinColumns_2 = joinEntitySchema && joinEntitySchema.columns;
                var tempArray_2 = temporaryJoinData[joinEntity] ? __spreadArrays(temporaryJoinData[joinEntity]) : [];
                var newArray_1 = [];
                entityData.data.forEach(function (deleteElement) {
                    var elementId = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && deleteElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
                    if (element_1 && elementId === (element_1 === null || element_1 === void 0 ? void 0 : element_1.key)) {
                        if (props.mainEntityId !== 'new') {
                            var entityId = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && entityData.joinContext[deleteElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn]].id;
                            entityId && deleteEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, joinEntity, fetchHeaders, entityId, setFetchResponse);
                        }
                        else {
                            joinColumns_2 && joinColumns_2.forEach(function (column) {
                                var changeElement = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && tempArray_2.find(function (elem) { return elem.data[column.name] === deleteElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn]; });
                                if (changeElement) {
                                    var index_2 = tempArray_2.findIndex(function (object) { return object.data[column.name] === changeElement.data[column.name]; });
                                    if (index_2 >= 0) {
                                        tempArray_2.map(function (elem, id) {
                                            if (index_2 !== id) {
                                                newArray_1.push(elem);
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }
                });
                var newTempJoinData = __assign({}, temporaryJoinData);
                newTempJoinData[joinEntity] = newArray_1;
                props.mainEntityId === 'new' && dispatch(crudeActions.setTemporaryJoinData(newTempJoinData));
            }
        }
        else {
            if (min && values.length < min) {
                setShowJoinEntityMultiSelectErrorMessage(t('crude:minimumSelectionError', { min: props.min }));
            }
            else {
                setShowJoinEntityMultiSelectErrorMessage(t('crude:maximumSelectionError', { max: props.max }));
            }
        }
    };
    react_1.useEffect(function () {
        setShowJoinEntityMultiSelectErrorMessage(undefined);
    }, [crudeLanguage]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (joinEntityLayout === configurationTypes_1.JoinEntityLayout.multiSelectDropdown || joinEntityLayout === configurationTypes_1.JoinEntityLayout.multiSelectAutoComplete) &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.Autocomplete, { multiple: true, options: getMultiSelectDropdownData(), value: getMultiSelectValues(), disableCloseOnSelect: true, clearIcon: getClearIcon(), disableClearable: props.min ? (props.min > 0) : false, isOptionEqualToValue: function (option, value) { return option.key === value.key; }, getOptionLabel: function (option) { return option.value; }, renderTags: function (tags, getTagProps) {
                        return tags.map(function (option, index) {
                            return (react_1.default.createElement(material_1.Chip, __assign({ label: TranslationComponent && (option.value.indexOf('t(') >= 0)
                                    ? react_1.default.createElement(TranslationComponent, { expression: option.value })
                                    : react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: dompurify_1.default.sanitize(option.value) } }) }, getTagProps({ index: index }))));
                        });
                    }, renderOption: function (props, option) {
                        return (react_1.default.createElement(material_1.Box, __assign({ component: 'li' }, props), option.description
                            ? (react_1.default.createElement(TooltipComponent_1.default, { title: option.description, placement: 'right', element: TranslationComponent && (option.value.indexOf('t(') >= 0)
                                    ? react_1.default.createElement(TranslationComponent, { expression: option.value })
                                    : react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: dompurify_1.default.sanitize(option.value) } }) }))
                            : TranslationComponent && (option.value.indexOf('t(') >= 0)
                                ? react_1.default.createElement(TranslationComponent, { expression: option.value })
                                : react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: dompurify_1.default.sanitize(option.value) } })));
                    }, PopperComponent: StyledPopper, onChange: function (event, newValue) {
                        handleChangeMultiSelectDropdown(newValue);
                    }, renderInput: function (params) {
                        var _a;
                        return (react_1.default.createElement(material_1.TextField, __assign({}, params, { disabled: joinEntityLayout === configurationTypes_1.JoinEntityLayout.multiSelectDropdown, error: !!showJoinEntityMultiSelectErrorMessage, helperText: showJoinEntityMultiSelectErrorMessage, required: props.min ? (props.min > 0) : false, onKeyDown: (function (e) {
                                e.stopPropagation();
                            }), InputLabelProps: {
                                shrink: true,
                                style: { pointerEvents: 'auto', display: 'flex', alignItems: 'center' },
                            }, label: joinEntityDescription &&
                                react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: joinEntityDescription }), sx: {
                                width: '100%',
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: theme.palette.primary.main,
                                    borderWidth: 2,
                                },
                            }, variant: (_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.type })));
                    } })),
        joinEntityLayout === configurationTypes_1.JoinEntityLayout.joinEntity &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(material_1.Grid, { xs: 12, container: true },
                    react_1.default.createElement(material_1.Grid, { xs: 3, item: true },
                        react_1.default.createElement(SearchComponent_1.default, { fullWidth: true, dataViewType: commonTypes_1.DataViewType.referenceView, entity: entity, treeviewLevel: props.treeViewLevel })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 9 },
                        react_1.default.createElement(material_1.Stack, { direction: 'row', justifyContent: 'end' },
                            react_1.default.createElement(FilterComponent_1.default, { justifyContent: 'flex-end', entity: entity, dataViewType: commonTypes_1.DataViewType.referenceView, treeviewLevel: props.treeViewLevel })))),
                react_1.default.createElement(material_1.Divider, { sx: { my: 3 } }),
                react_1.default.createElement(material_1.Grid, { container: true, alignItems: 'flex-start', alignContent: 'space-between', "justify-content": 'space-between', spacing: 3 },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 5 },
                        react_1.default.createElement(material_1.Typography, { variant: 'body2' },
                            react_1.default.createElement("b", null, joinEntityDescription)),
                        react_1.default.createElement(material_1.Paper, { className: classes.paper },
                            react_1.default.createElement(material_1.List, null, entityData.data.length !== 0 || (props.mainEntityId === 'new' && getFilteredEntityData(entityData).length !== 0)
                                ? (react_1.default.createElement(react_1.default.Fragment, null, props.mainEntityId === 'new'
                                    ? getFilteredEntityData(entityData).map(function (entityElement, index) {
                                        var elementId = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && entityElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
                                        var joinEntityId = entityData.joinContext[entityElement.id] ? entityData.joinContext[elementId].id : undefined;
                                        return (react_1.default.createElement(JoinEntityElement_1.default, { data: entityElement, thumbnailData: entityData.thumbnailData[elementId], joinContext: entityData.joinContext[elementId], schema: joinEntitySchema, joinEntityId: joinEntityId, entityReferencePreviews: entityData.entityReferencePreviews, joinEntityReferencePreviews: joinEntityData.entityReferencePreviews, treeViewLevel: props.treeViewLevel, dataViewType: props.dataViewType, entity: entity, joinEntity: joinEntity, key: index, joinListType: JoinListType.entityList, editEntity: function (element) { return setSingleEntity(element); }, selectEntity: function (id, checked) {
                                                var newList = entityData;
                                                var newData = __spreadArrays(newList.data);
                                                newData.map(function (element) {
                                                    if (element.id === id) {
                                                        element.selected = checked;
                                                    }
                                                    return element;
                                                });
                                                newList.data = newData;
                                                setEntityData(newList);
                                            } }));
                                    })
                                    : entityData.data.map(function (entityElement, index) {
                                        var elementId = (joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn) && entityElement[joinEntitySchema === null || joinEntitySchema === void 0 ? void 0 : joinEntitySchema.idColumn];
                                        var joinEntityId = entityData.joinContext[entityElement.id] ? entityData.joinContext[elementId].id : undefined;
                                        return (react_1.default.createElement(JoinEntityElement_1.default, { data: entityElement, thumbnailData: entityData.thumbnailData[elementId], joinContext: entityData.joinContext[elementId], schema: joinEntitySchema, joinEntityId: joinEntityId, entityReferencePreviews: entityData.entityReferencePreviews, joinEntityReferencePreviews: joinEntityData.entityReferencePreviews, treeViewLevel: props.treeViewLevel, dataViewType: props.dataViewType, entity: entity, joinEntity: joinEntity, key: index, joinListType: JoinListType.entityList, editEntity: function (element) { return setSingleEntity(element); }, selectEntity: function (id, checked) {
                                                var newList = entityData;
                                                var newData = __spreadArrays(newList.data);
                                                newData.map(function (element) {
                                                    if (element.id === id) {
                                                        element.selected = checked;
                                                    }
                                                    return element;
                                                });
                                                newList.data = newData;
                                                setEntityData(newList);
                                            } }));
                                    })))
                                : (react_1.default.createElement(material_1.Typography, { style: { textAlign: 'center' } },
                                    t('crude:noContent'),
                                    entityFilterSettings.filter && Object.keys(entityFilterSettings.filter).length !== 0 &&
                                        t('crude:resetFilter'))))),
                        props.mainEntityId !== 'new' &&
                            react_1.default.createElement(material_1.TablePagination, { component: 'div', count: entityData.totalElements, rowsPerPage: entityFilterSettings.pageSize, page: entityFilterSettings.page, backIconButtonProps: {
                                    'aria-label': "" + t('crm:lastPage'),
                                }, nextIconButtonProps: {
                                    'aria-label': "" + t('crm:nextPage'),
                                }, onPageChange: handleChangeEntityPage, onRowsPerPageChange: handleChangeEntityPageSize })),
                    react_1.default.createElement(material_1.Grid, { item: true, container: true, xs: 2 },
                        createAllowed &&
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(material_1.Grid, { item: true, xs: 3, textAlign: 'center' },
                                    react_1.default.createElement(IconComponent_1.default, { onClick: function () { return handleSwitchLeft(true); }, icon: react_1.default.createElement(KeyboardDoubleArrowLeft_1.default, { sx: { fontSize: '1.8rem' } }) })),
                                react_1.default.createElement(material_1.Grid, { item: true, xs: 3, textAlign: 'center' },
                                    react_1.default.createElement(IconComponent_1.default, { onClick: function () { return handleSwitchLeft(false); }, icon: react_1.default.createElement(KeyboardArrowLeft_1.default, { sx: { fontSize: '1.8rem' } }) }))),
                        deleteAllowed &&
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(material_1.Grid, { item: true, xs: 3, textAlign: 'center' },
                                    react_1.default.createElement(IconComponent_1.default, { onClick: function () { return handleSwitchRight(false); }, icon: react_1.default.createElement(KeyboardArrowRight_1.default, { sx: { fontSize: '1.8rem' } }) })),
                                react_1.default.createElement(material_1.Grid, { item: true, xs: 3, textAlign: 'center' },
                                    react_1.default.createElement(IconComponent_1.default, { onClick: function () { return handleSwitchRight(true); }, icon: react_1.default.createElement(KeyboardDoubleArrowRight_1.default, { sx: { fontSize: '1.8rem' } }) })))),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 5 },
                        react_1.default.createElement(material_1.Typography, { variant: 'body2' },
                            react_1.default.createElement("b", null, t('crude:available') + " " + entityDescription)),
                        react_1.default.createElement(material_1.Paper, { className: classes.paper },
                            react_1.default.createElement(material_1.List, null, joinEntityData.data.length !== 0
                                ? joinEntityData.data.map(function (entityElement, index) {
                                    return (react_1.default.createElement(JoinEntityElement_1.default, { data: entityElement, schema: joinEntitySchema, entityReferencePreviews: entityData.entityReferencePreviews, joinEntityReferencePreviews: joinEntityData.entityReferencePreviews, treeViewLevel: props.treeViewLevel, dataViewType: props.dataViewType, entity: entity, joinEntity: joinEntity, key: index, joinListType: JoinListType.joinList, editEntity: function (element) { return setSingleEntity(element); }, selectEntity: function (id, checked) {
                                            var newList = joinEntityData;
                                            var newData = __spreadArrays(newList.data);
                                            newData.map(function (element) {
                                                if (element.id === id) {
                                                    element.selected = checked;
                                                }
                                                return element;
                                            });
                                            newList.data = newData;
                                            setJoinEntityData(newList);
                                        } }));
                                })
                                : (react_1.default.createElement(material_1.Typography, { style: { textAlign: 'center' } },
                                    t('crude:noContent'),
                                    joinFilterSettings.filter && Object.keys(joinFilterSettings.filter).length !== 0 &&
                                        t('crude:resetFilter'))))),
                        props.mainEntityId !== 'new' &&
                            react_1.default.createElement(material_1.TablePagination, { component: 'div', count: joinEntityData.totalElements, rowsPerPage: joinFilterSettings.pageSize, page: joinFilterSettings.page, backIconButtonProps: {
                                    'aria-label': "" + t('crm:lastPage'),
                                }, nextIconButtonProps: {
                                    'aria-label': "" + t('crm:nextPage'),
                                }, onPageChange: handleChangeJoinPage, onRowsPerPageChange: handleChangeJoinPageSize }))),
                singleEntity &&
                    react_1.default.createElement(CrudeDialogComponent_1.default, { onClose: function () {
                            dispatch(crude_actions_1.setShowDialog(false));
                        }, content: react_1.default.createElement(DataEditView_1.default, { disableJoinColumns: disabledJoinColumns, embeddingEntityFilter: props.embeddingEntityFilter, dataViewType: commonTypes_1.DataViewType.simpleView, entity: singleEntity.entity, id: singleEntity.id ? singleEntity.id : undefined, treeViewLevel: props.treeViewLevel + 1, hideBackButton: true, showInPopup: true }) }))));
};
exports.default = JoinEntity;
